import { defineStore } from 'pinia'
import { useNuxtApp, navigateTo } from '#imports'
import { signOut } from 'firebase/auth'
import { doc, getDoc, setDoc } from 'firebase/firestore'

export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null as any | null,
        userProfile: null as any | null,
        loading: false,
        isInitialSyncDone: false
    }),

    getters: {
        isAuthenticated: (state) => !!state.user,
        isAdmin: (state) => {
            // Allow all authenticated users to view admin panel for demonstration
            return !!state.user
        }
    },

    actions: {
        setUser(user: any) {
            this.user = user
            if (user && process.client) {
                this.fetchUserProfile(user.uid)
            } else if (!user) {
                this.userProfile = null
            }
        },

        async fetchUserProfile(uid: string) {
            try {
                if (process.client) {
                    const { $db } = useNuxtApp() as any
                    const docRef = doc($db, 'users', uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        this.userProfile = docSnap.data()
                    } else {
                        this.userProfile = null
                    }
                }
            } catch (error) {
                console.error('Error fetching user profile:', error)
            }
        },

        async updateUserProfile(uid: string, data: any) {
            try {
                if (process.client) {
                    const { $db } = useNuxtApp() as any
                    const docRef = doc($db, 'users', uid)
                    await setDoc(docRef, data, { merge: true })
                    this.userProfile = { ...this.userProfile, ...data }
                }
            } catch (error) {
                console.error('Error updating user profile:', error)
                throw error
            }
        },

        async logout() {
            const { $auth } = useNuxtApp()
            try {
                await signOut($auth as any)
                this.user = null
                navigateTo('/auth/login')
            } catch (error) {
                console.error('Logout error:', error)
            }
        },

        async waitForAuth() {
            if (this.isInitialSyncDone) return
            
            return new Promise((resolve) => {
                const unwatch = this.$subscribe((mutation, state) => {
                    if (state.isInitialSyncDone) {
                        unwatch()
                        resolve(true)
                    }
                })
            })
        }
    }
})
